// Global
import React from 'react';
import styles from './ProductHeroDecor.module.scss';
import clsx from 'clsx';

export const ProductHeroDecor = () => {
  return (
    <div className={clsx(styles.decorWrapper)}>
      <svg
        className={styles.decorColor}
        xmlns="http://www.w3.org/2000/svg"
        width="1400"
        height="331"
        fill="none"
      >
        <g clipPath="url(#clip0_21544_177017)">
          <rect width="1440" height="64" fill="currentColor" />
        </g>
        <defs>
          <clipPath id="clip0_21544_177017">
            <rect width="1440" height="64" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
